export const getParams = (query: string = '?') => {
    return query
        .slice(1)
        .split('&')
        .reduce((params, param) => {
            const [key, value] = param.split('=');
            if (key) {
                params[key] = value ? decodeURIComponent(value) : undefined;
            }
            return params;
        }, {});
};

export const getFilterParams = (query: string = '?') => {
    return query
        .slice(1)
        .split('&')
        .reduce((params, param) => {
            const [key, value] = param.split('=');
            if (key && key.startsWith('_')) {
                params[key.slice(1)] = value ? decodeURIComponent(value) : undefined;
            }
            return params;
        }, {});
};


// WEBPACK FOOTER //
// ./src/utils/getParams.ts